
import { format } from 'date-fns'

export default {
  name: 'SuccessStory',

  props: {
    document: {
      type: Object,
      required: false,
      default: undefined,
    },
    nextSuccessStory: {
      type: Object,
      required: false,
      default: undefined,
    },
    prevSuccessStory: {
      type: Object,
      required: false,
      default: undefined,
    },
  },

  computed: {
    date() {
      return format(new Date(this.document.last_publication_date), 'PP')
    },

    fullUrl() {
      return this.encodeURI(`https://www.nurole.com${this.$route.path}`)
    },

    title() {
      return this.encodeURI(this.document.data.title)
    },

    shareFacebook() {
      const imageUrl = this.encodeURI(this.document.data.company_logo.url)
      const summary = this.encodeURI(this.document.data.subtitle || '')
      return `http://www.facebook.com/sharer/sharer.php?u=${this.fullUrl}&picture=${imageUrl}&title=${this.title}&description=${summary}&caption=Nurole`
    },

    shareTwitter() {
      return `https://twitter.com/intent/tweet?url=${this.fullUrl}&via=NuroleCom&text=${this.title}`
    },

    shareLinkedin() {
      const imageUrl = this.encodeURI(this.document.data.company_logo.url)
      const title = this.encodeURI(
        this.document.data.company_name[0].text.slice(0, 200)
      )
      const summary = this.encodeURI(this.document.data.role_title[0].text)

      return `https://www.linkedin.com/shareArticle?url=${this.fullUrl}&image_url=https:${imageUrl}&mini=true&title=${title}&summary=${summary}&source=Nurole`
    },

    shareEmail() {
      return `mailto:?body=${this.fullUrl}&subject=${this.title}`
    },
  },

  methods: {
    encodeURI(url) {
      return encodeURIComponent(url)
    },

    sharePrint() {
      if (window.print) window.print()
    },
  },
}
